export default {
    getCompanyBranches: { method: 'get', url: 'companies/branches' },
    postCompanyBranches: { method: 'post', url: 'companies/branches' },
    updateCompanyBranches: { method: 'put', url: 'companies/branches/{id}' },
    deleteCompanyBranches: { method: 'delete', url: 'companies/branches/{id}' },
}
